import React, {Component} from 'react';

//library
import moment from 'moment';

//scss
import thanksInfostyles from '../../static/css/componentStyleModules/thanksInfoSheet.module.scss';


import ThanksButtonComponent from './ThanksButtonComponent';

//API
// import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI.js';
import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';


export default class ThanksInfoSheetComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
        }
    }

    render() {

        const thanksDate = (dateIntString) => {
            if(dateIntString !== undefined){
                const dateString = moment(dateIntString).format('YYYY年MM月DD日')
                //多言語対応
                const dayOfTheWeek = moment(dateIntString).toDate().getDay();
                const dayOfTheWeekArray = ['Sun','Mon','Tue','Wed','Thu','Fry','Sat']
                
                return dateString + ' (' + dayOfTheWeekArray[dayOfTheWeek] + ')';
            }else{
                return '';
            }
        }

        const sheetFunctionButton = (buttonAction,icon,buttonStr,deleteButton) => {
            const memberColor = this.props.thankData.Members.color !== null ? this.props.thankData.Members.color : '#888888';

            return (
                <div className={thanksInfostyles['functionButton'] + ' touchActiveDark'}
                onClick={buttonAction}
                >
                  <div className={thanksInfostyles['iconArea']}
                  style={ deleteButton ? null : {backgroundColor:memberColor}}
                  >
                    <div className={thanksInfostyles['icon']}>
                      <SvgIconBaseComponent 
                      image={icon} 
                      fillColor={deleteButton ? '#c7243a' : '#ffffff'} 
                      />
                    </div>
                  </div>
                  <span>{buttonStr}</span>
                </div>
            )
        }


        return (
          <div>
            <div className={thanksInfostyles['thanksInfoSheet']}
            onClick={() => this.props.onSheetClick() }>
              <div className={thanksInfostyles['sheetBlock']} 
              style={{borderColor:this.props.thankData.Members.color !== null ? this.props.thankData.Members.color : '#888888'}}>
                <div className={thanksInfostyles['infoArea']}>
                  <time>{thanksDate(this.props.thankData.Thanks.date)}</time>
                  <h2>{this.props.thankData.Thanks.title}</h2>
                  <div className={thanksInfostyles['memberName']} 
                  >
                    {this.props.thankData.Members.name !== null ? this.props.thankData.Members.name : 'ななしさん'}
                  </div>
                  {this.props.thankData.Thanks.memo !== undefined 
                    ? <p>{this.props.thankData.Thanks.memo}</p> 
                    :null
                  }
                </div>
                <div className={thanksInfostyles['memberIcon']}>
                  <FaceIconBaseComponent 
                  head={this.props.thankData.Members.head !== null ? this.props.thankData.Members.head : 'basic'} 
                  eyes={this.props.thankData.Members.eyes !== null ? this.props.thankData.Members.eyes : 'basic'} 
                  eyeblows={this.props.thankData.Members.eyeblows !== null ? this.props.thankData.Members.eyeblows : 'none'} 
                  mouth={this.props.thankData.Members.mouth !== null ? this.props.thankData.Members.mouth : 'basic'} 
                  fillColor={this.props.thankData.Members.color !== null ? this.props.thankData.Members.color : '#888888'} />
                </div>
              </div>

              <div className={thanksInfostyles['buttonArea']}>

                <div className={thanksInfostyles['leftArea']}>
                  {sheetFunctionButton(this.props.onDelButtonClick,'heartBreak','忘れる',true)}
                </div>
                <div className={thanksInfostyles['rightArea']}>
                  {sheetFunctionButton(this.props.onEditButtonClick,'pencil','編集')}
                  {sheetFunctionButton(this.props.onCardMakeButtonClick,'thanksCard','カード')}

                  <div className={thanksInfostyles['functionButton']}>
                    <div className={thanksInfostyles['iconArea']}>
                      <div className={thanksInfostyles['checkIcon']}>
                        <ThanksButtonComponent 
                        thankData={this.props.thankData.Thanks}
                        type="round"
                        status={this.props.thankData.Thanks.check}
                        onRewriteBackData={(data) => this.props.onThanksButtonClick(data)}
                        />
                      </div>
                    </div>
                    <span>チェック</span>
                  </div>

                </div>
              </div> 

            </div>


          </div>
        )
    }

};